<section class="mb-5" *ngFor="let month of months">
  <h2 class="h5 mb-3 pb-2 border-bottom">{{ month.label || (month.month | date:'MMMM y') }}</h2>

  <!-- Highlights: clip beside one sentence, plays on its own -->
  <div class="row g-3 align-items-center mb-4" *ngFor="let item of month.highlights">
    <div class="col-12 col-md-6">
      <video appPlayInView
             class="w-100 d-block rounded shadow-sm bg-light"
             [src]="item.videoUrl + '#t=0.1'"
             preload="metadata"
             muted
             loop
             playsinline
             disablepictureinpicture
             disableremoteplayback
             aria-hidden="true"></video>
    </div>
    <div class="col-12 col-md-6">
      <div class="small text-muted mb-1">{{ item.area }}</div>
      <p class="fs-6 mb-0">{{ item.text }}</p>
    </div>
  </div>

  <!-- Everything else -->
  <ul class="mb-0 ps-4" *ngIf="month.others.length">
    <li class="mb-2" *ngFor="let item of month.others">{{ item.text }}</li>
  </ul>
</section>

<p class="text-muted" *ngIf="months.length === 0">No updates yet.</p>
